<template>
  <div>
    <v-dialog v-model="materialsInfoDialog" width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $t("Wave.StockSortingFields.material_info")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="materialsInfoDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Wave.PickingFields.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="2" class="font-weight-bold text-left">
                {{
                  $t("Wave.StockSortingFields.stock_out_code") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="4">
                {{
                  sortingLocationDetail
                    ? sortingLocationDetail.stock_order_code
                    : ""
                }}
              </v-col>
              <v-col cols="2" class="font-weight-bold text-left">
                {{
                  $t("Wave.StockSortingFields.sorting_location") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="4">
                {{
                  sortingLocationDetail
                    ? sortingLocationDetail.location_num
                    : ""
                }}
              </v-col>
            </v-row>

            <ValidationObserver ref="observer">
              <v-data-table
                id="materials_info_table"
                :headers="detailsHeaders"
                :items="materialList"
                disable-sort
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item.material_name="{ item }">
                  <span>
                    {{
                      $t(settings
                          ? settings.material_name_display_type == 1
                              ? "Material.materialName"
                              : settings.material_name_display_type == 4
                                  ? "Material.nameWithCode"
                              : "Material.materialNameWithCode"
                          : "Material.materialName", [item.material_code, item.material_name])
                    }}
                  </span>
                  <br />
                  <span class="caption secondary--text">
                    {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                    <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                      {{ item.standard_name.slice(0, 12) + "......" }}
                    </span>
                    <span v-else>
                      {{ item.standard_name }}
                    </span>
                  </span>
                </template>
                <template v-slot:item.stock_confirm_num="{ item }">
                  {{ item.stock_confirm_num }}
                </template>
                <template v-slot:item.confirm_num="{ item }">
                  {{ item.confirm_num | formatTwoDot }}
                </template>
                <template v-slot:item.unit="{ item }">
                  {{ item.unit }}
                </template>
                <template v-slot:item.sorting_num="{ item }">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('StockContainers.Fields.bar_code')"
                    :rules="{ max_value: { max: item.confirm_num } }"
                  >
                    <span
                      v-if="item.stock_rate > 1"
                    >
                      <SortingDialogNumberInput
                        v-model="item.sorting_num_rate"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'sorting_num')
                            .concat(errors)
                        "
                        :material="item"
                        v-on:material="
                          item = JSON.parse(JSON.stringify($event))
                        "
                        allowNegative
                        dense
                      >
                        <template v-slot:append>
                          {{ item.stock_unit }}
                        </template>
                      </SortingDialogNumberInput>
                      <SortingDialogNumberInput
                        v-model="item.sorting_num_default"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'sorting_num')
                            .concat(errors)
                        "
                        :material="item"
                        v-on:material="
                          item = JSON.parse(JSON.stringify($event))
                        "
                        allowNegative
                        dense
                      >
                        <template v-slot:append>
                          {{ item.unit }}
                        </template>
                      </SortingDialogNumberInput>
                    </span>
                    <span v-else>
                      <SortingDialogNumberInput
                        v-model="item.sorting_num"
                        :error-messages="errors"
                        :material="item"
                        v-on:material="
                          item = JSON.parse(JSON.stringify($event))
                        "
                        allowNegative
                        dense
                      >
                        <template v-slot:append>
                          {{ item.unit }}
                        </template>
                      </SortingDialogNumberInput>
                    </span>
                  </ValidationProvider>
                </template>
                <template v-slot:item.sorting_num_rate="{ item }">
                  <span v-if="item.stock_rate > 1">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('StockContainers.Fields.bar_code')"
                      :rules="{ max_value: { max: item.confirm_num } }"
                    >
                      <SortingDialogNumberInput
                        v-model="item.sorting_num_rate"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'sorting_num')
                            .concat(errors)
                        "
                        :material="item"
                        v-on:material="
                          item = JSON.parse(JSON.stringify($event))
                        "
                        allowNegative
                        dense
                      />
                    </ValidationProvider>
                  </span>
                </template>
                <template v-slot:item.sorting_num_default="{ item }">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('StockContainers.Fields.bar_code')"
                    :rules="{ max_value: { max: item.confirm_num } }"
                  >
                      <SortingDialogNumberInput
                        v-model="item.sorting_num_default"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'sorting_num')
                            .concat(errors)
                        "
                        :material="item"
                        v-on:material="
                          item = JSON.parse(JSON.stringify($event))
                        "
                        allowNegative
                        dense
                      />
                  </ValidationProvider>
                </template>
              </v-data-table>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="materialsInfoDialog = false"
            >{{ $t("$vuetify.close") }}</v-btn
          >
          <v-btn color="accent" @click="confirmSortingMaterialNum()">{{
            $t("$vuetify.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SortingDialogNumberInput from "./SortingDialogNumberInput";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "materialsInfoDialog",

  props: {
    value: Boolean,
    sortingLocationDetail: Object,
    sortingDetails: Array,
  },

  components: {
    SortingDialogNumberInput,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Wave.StockSortingFields.material_name"),
          align: "center",
          value: "material_name",
        },
      ];
      if (this.$i18n.locale == "zhHans") {
        headers.push({
          text: i18n.t("Wave.StockSortingFields.stock_out_num"),
          align: "center",
          value: "stock_confirm_num",
        });
      } else {
        headers.push(
          {
            text: i18n.t("Wave.StockSortingFields.stock_out_num"),
            align: "center",
            value: "confirm_num",
          },
          {
            text: i18n.t("Wave.StockSortingFields.unit"),
            align: "center",
            value: "unit",
          }
        );
      }

      if (this.$i18n.locale == "zhHans") {
        headers.push({
          text: i18n.t("Wave.StockSortingFields.finished_sorting_material_num"),
          align: "center",
          value: "sorting_num",
        });
      } else {
        headers.push(
          {
            text: i18n.t(
              "Wave.StockSortingFields.finished_sorting_material_num_with_stock_unit"
            ),
            align: "center",
            value: "sorting_num_rate",
          },
          {
            text: i18n.t(
              "Wave.StockSortingFields.finished_sorting_material_num_with_default_unit"
            ),
            align: "center",
            value: "sorting_num_default",
          }
        );
      }

      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    materialsInfoDialog: false,
    materialList: [],
    sorted_num: 0,
    serverErrors: [],
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.materialsInfoDialog = this.value;
      },
    },
    materialsInfoDialog: {
      handler() {
        this.$emit("input", this.materialsInfoDialog);
        if (!this.materialsInfoDialog) {
          this.$emit("close");
          this.$emit("sortingLocationDetail", this.sortingLocationDetail);
        }
      },
    },
    sortingLocationDetail: {
      handler() {
        this.materialList = this.sortingLocationDetail
          ? Object.values(this.sortingLocationDetail.material)
          : null;
      },
    },
  },

  methods: {
    confirmSortingMaterialNum() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            //获取分拣的商品
            var sorted_num = this.sortingLocationDetail.sorted_num; //已分拣完的商品
            var update_sorting_status = false;

            for (var key in this.sortingLocationDetail.material) {
              var material = this.sortingLocationDetail.material[key];

              //多单位情况下判断分拣数量是否拣超
              if (material.stock_rate > 1) {
                material.sorting_num = 0;
                if (material.sorting_num_rate)
                  material.sorting_num =
                    material.sorting_num_rate * material.stock_rate;

                if (material.sorting_num_default)
                  material.sorting_num += material.sorting_num_default;

                if (material.sorting_num)
                  material.sorting_num = material.sorting_num.toFixed(2);

                if (material.sorting_num > material.confirm_num) {
                  this.serverErrors = [
                    {
                      field: "sorting_num",
                      text: "",
                      msg: i18n.t(
                        "Wave.Messages.sorting_num_more_than_confirm_num"
                      ),
                    },
                  ];
                }
              }
              if (
                this.sortingLocationDetail.material[key].lockable &&
                !this.sortingLocationDetail.material[key].sorting_all
              ) {
                //部分分拣
                if (
                  this.sortingLocationDetail.material[key].lockable &&
                  this.sortingLocationDetail.material[key].sorting_num <
                    this.sortingLocationDetail.material[key].confirm_num
                ) {
                  update_sorting_status = true;
                }
                //全部分拣
                if (
                  this.sortingLocationDetail.material[key].sorting_num ==
                  this.sortingLocationDetail.material[key].confirm_num
                ) {
                  this.sortingLocationDetail.material[key].sorting_all = true;
                  ++sorted_num;
                }
              }
            }

            if (
              sorted_num ==
              Object.values(this.sortingLocationDetail.material).length
            ) {
              this.sortingLocationDetail.sort_status = 3;
              this.sortingLocationDetail.sorted_num = sorted_num;
            }

            if (
              update_sorting_status &&
              sorted_num <
                Object.values(this.sortingLocationDetail.material).length
            ) {
              this.sortingLocationDetail.sort_status = 2;
              this.sortingLocationDetail.sorted_num = sorted_num;
            }

            this.materialsInfoDialog = false;
          }
        }.bind(this)
      );
    },
  },
};
</script>